import FullTextSearch from "./FullTextSearch"

export default  FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SubHeader/FullTextSearch/index.js